import { StyleSheet } from 'react-native';

import { THEME } from './reactor/common';

const { COLOR } = THEME;

export default StyleSheet.create({
  app: {
    backgroundColor: COLOR.BLACK,
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
});
